import { Component, AfterViewChecked, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CommonDataService } from '../../common/services/common-data.service';
import { LoginService } from '../../common/services/Login.service';
import { GraphqlService } from '../../common/services/graphql.service';
import { OpenLinkById } from '../../common/services/openlinkbyid';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { UtilityService } from '../../common/services/utility-service';
import { constObj } from '../../common/Constants/constants';
import { ConfirmDialogComponent } from '../../common/shared-components/confirm-dialog/confirm-dialog.component';
@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AboutUsComponent implements OnInit, AfterViewChecked {

  constructor(
    public commonDataService: CommonDataService,
    public loginService: LoginService,
    private graphQlService: GraphqlService,
    private openlink: OpenLinkById,
    private sanitizer: DomSanitizer,
    private router: Router,    
    public dialog: MatDialog,
    private utilityService: UtilityService) {
    this.isArchiveApplication();
    if (this.router.url.toLowerCase().includes("login")) { this.isLoginPage = true; }
  }
  about_header;
  about_content;
  about_compatibilityHeader;
  about_browsers;
  about_otherApplications;
  archiveVersion: string = "";
  isArchive: boolean = false;
  isLoginPage: boolean = false;

  ngOnInit(): void {
    this.commonDataService.showLoader.next(true);
    this.getaboutuscomponentlabels();
  }
  starting: boolean = true;
  ngAfterViewChecked() {
    if (this.starting) {
      this.starting = false;
      this.anchorColorChange();
    }
  }

  anchorColorChange() {
    let item1 = document.getElementById('about_content').getElementsByTagName("span") as HTMLCollectionOf<HTMLElement>;
    for (let i = 0; i < item1.length; i++) {
      let element = item1[i];
      element.style.fontStyle = "";
      element.style.fontWeight = "";
    }
  }

  getaboutuscomponentlabels() {
    this.graphQlService.getAboutUsComponentLabel().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.about_header = labels.filter(x => x.key == "about_header").map(y => y.value);
        this.about_content = labels.filter(x => x.key == "about_content").map(y => y.value);
        this.about_compatibilityHeader = labels.filter(x => x.key == "about_compatibilityHeader").map(y => y.value);
        this.about_browsers = labels.filter(x => x.key == "about_browsers").map(y => y.value);
        this.about_otherApplications = labels.filter(x => x.key == "about_otherApplications").map(y => y.value);
        this.commonDataService.showLoader.next(false);
      }
    });
  }
  openLinkById(event) {
    this.openlink.openLinkById(event);
  }
  isArchiveApplication() {
    this.archiveVersion = localStorage.getItem("ArchiveVersion");
    if (localStorage.getItem("publicationId") != undefined && localStorage.getItem("currentVersionPublicationId") != localStorage.getItem("publicationId")) {
      this.archiveVersion = this.utilityService.convertMonthYear(localStorage.getItem("ArchiveVersion"));
      this.isArchive = Boolean(this.archiveVersion);
    }
    else if (this.router.url.split("/")[1] != localStorage.getItem("currentVersionPublicationId") && (this.archiveVersion != null && this.archiveVersion != undefined)) {
      this.archiveVersion = localStorage.getItem("ArchiveVersion");
      this.isArchive = Boolean(this.archiveVersion);
    }
    else { this.isArchive = false; }
  }
  BackToCurrentContent() {
    const PrintQueueSession = localStorage.getItem("SetPrintQueueSession");
    var printQueueCount: any = PrintQueueSession == "{}" ? 0 : PrintQueueSession == null ? 0 : PrintQueueSession == "" ? 0 : JSON.parse(localStorage.getItem("SetPrintQueueSession")).ParagraphIdsList.length;
    let popUpMessage = constObj.currentVersionNavigationAlert;
    if (printQueueCount > 0) {
      popUpMessage += "<br/>" + constObj.annotationAlertPrintQueue;
    }
    else { popUpMessage += "<br/>" + constObj.continueMessage; }
    localStorage.setItem("isConfirmPopup", "true");
    this.commonDataService.isConfirmationPopUpOpen.next(true);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '600px',
      data: popUpMessage
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      localStorage.removeItem("isConfirmPopup");
      if (result == true) {
        this.commonDataService.resetPrintQueue.next(true);
        this.commonDataService.printCount.next("toggleOff");
        this.commonDataService.printToggleOff.next("printToggleOff");
        localStorage.removeItem("ArchiveVersion");
        this.commonDataService.loadCurrentLeftNav.next(localStorage.getItem("currentVersionPublicationId"));
        this.router.navigateByUrl("/Home")
      }
    });
  }
}
